import Vue from 'vue'
import Router from 'vue-router'
import store from '../store/index'

import Login from '@/components/auth/Login'
import Registration from '@/components/auth/Registration'
import PasswordResetRequest from '@/components/auth/PasswordResetRequest'
import PasswordReset from '@/components/auth/PasswordReset'
import Logout from '@/components/auth/Logout'
import AccountSettings from '@/components/account/Settings'
import Subscription from '@/components/account/Subscription'

import Dashboard from '@/components/dashboard/Dashboard'

import Ledger from '@/components/ledger/Ledger'
import CreateLedger from '@/components/ledger/CreateLedger'

import Support from '@/components/support/Support'
import NotFound from '@/components/support/NotFound'
import TheStory from '@/components/support/TheStory'
import Ledgers from '@/components/support/Ledgers'
import Contact from '@/components/support/Contact'
import ExampleLedger from '@/components/support/ExampleLedger'
import Expenses from '@/components/support/Expenses'
import DashboardSupport from '@/components/support/Dashboard'
import AddToHomeScreen from '@/components/support/AddToHomeScreen'
import KeyboardShortcuts from '@/components/support/KeyboardShortcuts'

import PrivacyPolicy from '@/components/legal-agreements/PrivacyPolicy'
import CookiePolicy from '@/components/legal-agreements/CookiePolicy'
import TermsOfService from '@/components/legal-agreements/TermsOfService'

Vue.use(Router)

const router = new Router({
  routes: [
    { path: '/', alias: '/login', name: 'Login', component: Login, meta: { requiresGuest: true } },
    { path: '/registration', name: 'Registration', component: Registration, meta: { requiresGuest: true } },
    { path: '/reset-password-request', name: 'PasswordResetRequest', component: PasswordResetRequest, meta: { requiresGuest: true } },
    { path: '/reset-password/:token', name: 'PasswordReset', component: PasswordReset, meta: { requiresGuest: true } },
    { path: '/logout', name: 'Logout', component: Logout, meta: { requiresAuth: true } },
    { path: '/dashboard', name: 'Dashboard', component: Dashboard, meta: { requiresAuth: true } },
    { path: '/account-settings', name: 'AccountSettings', component: AccountSettings, meta: { requiresAuth: true } },
    { path: '/subscription', name: 'Subscription', component: Subscription, meta: { requiresAuth: true } },
    { path: '/ledger/create', name: 'CreateLedger', component: CreateLedger, meta: { requiresAuth: true, requiresSubscription: true } },
    { path: '/ledger/:id', name: 'Ledger', component: Ledger, meta: { requiresAuth: true, requiresSubscription: true } },
    { path: '/support', name: 'Support', component: Support, meta: { requiresAuth: true } },
    { path: '/support/the-story', name: 'TheStory', component: TheStory, meta: { requiresAuth: true } },
    { path: '/support/ledgers', name: 'Ledgers', component: Ledgers, meta: { requiresAuth: true } },
    { path: '/support/expenses', name: 'Expenses', component: Expenses, meta: { requiresAuth: true } },
    { path: '/support/dashboard', name: 'DashboardSupport', component: DashboardSupport, meta: { requiresAuth: true } },
    { path: '/support/contact', name: 'Contact', component: Contact, meta: { requiresAuth: true } },
    { path: '/support/example-ledger', name: 'ExampleLedger', component: ExampleLedger, meta: { requiresAuth: true } },
    { path: '/support/add-to-home-screen', name: 'AddToHomeScreen', component: AddToHomeScreen, meta: { requiresAuth: true } },
    { path: '/support/keyboard-shortcuts', name: 'KeyboardShortcuts', component: KeyboardShortcuts, meta: { requiresAuth: true } },
    { path: '/privacy-policy', name: 'PrivacyPolicy', component: PrivacyPolicy },
    { path: '/cookie-policy', name: 'CookiePolicy', component: CookiePolicy },
    { path: '/terms-of-service', name: 'TermsOfService', component: TermsOfService },
    { path: '/not-found', name: 'NotFound', component: NotFound }
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

router.beforeEach((to, from, next) => {
  /*
  Store the referral_id from the query string
  */
  if (typeof to.query.referral_id !== 'undefined') {
    console.log(to.query.referral_id)
    localStorage.setItem('referral_id', to.query.referral_id)
  }

  /*
  Store the current route in the local storage (iOs Safari add to home screen fix)
  */
  localStorage.setItem('route_path', to.path)

  /*
  Always set the modal as closed when changing routes
   */
  store.commit('SET_MODAL_CLOSED')

  if (!to.matched.length) {
    next('/not-found')
  } else if (to.matched.some(record => record.meta.requiresSubscription) && store.state.auth.accessToken && store.state.account.me && !store.state.account.me.subscription.active && !store.state.account.me.subscription.trial && store.state.app.subscriptionEnabled) {
    next('/subscription')
  } else if (to.matched.some(record => record.meta.requiresAuth) && !store.state.auth.accessToken) {
    next('/login')
  } else if (to.matched.some(record => record.meta.requiresGuest) && store.state.auth.accessToken) {
    next('/dashboard')
  } else {
    next()
  }
})

export default router
